import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import {
  IconAnalitics,
  IconAdminPanel,
  IconUsersSideBar,
} from 'Stories/Icon/Icon.stories'
import { analytics, artists, curators, admin } from 'Router/routes'
import SidebarLink from '../SidebarLink'
import { AdminBlockProps } from './AdminBlockProps'

import {
  SidebarLinkItem,
  SidebarIconBlock,
  SidebarLinkText,
  AnaliticsUsersBlock,
} from './styles'

const AdminBlock: FunctionComponent<AdminBlockProps> = ({
  onClickHandle,
  toggleSubAnalyticsLinkOpen,
  collapse,
  isSubAnalyticsLinkOpen,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <SidebarLink
        icon={<IconAdminPanel />}
        route={admin}
        title="Admin Panel"
        onClick={onClickHandle}
      />

      {/* <SidebarLinkItem onClick={toggleSubAnalyticsLinkOpen}>
        <SidebarIconBlock>
          <IconAnalitics />
        </SidebarIconBlock>
        {!collapse ? (
          <SidebarLinkText>{t('analytics.analytics')}</SidebarLinkText>
        ) : (
          <SidebarLinkText />
        )}
      </SidebarLinkItem> */}

      {isSubAnalyticsLinkOpen && (
        <AnaliticsUsersBlock>
          <SidebarLink
            icon={<IconUsersSideBar />}
            route={`${analytics}${artists}`}
            title={t('campaignsPage.artists')}
            onClick={onClickHandle}
          />
          <SidebarLink
            icon={<IconUsersSideBar />}
            route={`${analytics}${curators}`}
            title={t('analytics.curators')}
            onClick={onClickHandle}
          />
        </AnaliticsUsersBlock>
      )}
    </>
  )
}
export default AdminBlock
